export const curriculumTabNamesT = ["list", "studentview", "syllabus"] as const;
export type CurriculumTabNameT = typeof curriculumTabNamesT[number];

export function isCurriculumTabNameT(str: string): str is CurriculumTabNameT {
  return curriculumTabNamesT.some(v => v === str);
}
